import React, {useRef, useState, useEffect} from 'react';
import useLiveness from "./hooks/useLiveness";
import './index.css'
import LoaderLulo from '../../../components/loaderLulo';
import LoaderIOS from '../../../components/loaderIOS';
import checkicon from '../../../assets/image/lulo/check.png'
import Alert from './components/Alert';
import {useLocation} from "react-router-dom";

export default function LivenessV5Wraper() {
    const location = useLocation();
    const [config, setConfig] = useState({});
    const [configLoading, setLoading] = useState(true);

    // get project name from query params
    const params = new Proxy(new URLSearchParams(window.location.search), {
        get: (searchParams, prop) => searchParams.get(prop),
    });

    const projectName = params.projectName || 'Default'

    // get the url based on the current page
    const url = () => {
        if (location.pathname.includes('card-capture')) {
            return `https://lnesv3-conf.ado-tech.com/${projectName}/CardCapture/config.json`;
        }
        return `https://lnesv3-conf.ado-tech.com/${projectName}/Liveness/config.json`;
    }
    const defaultUrl = () => {
        if (location.pathname.includes('card-capture')) {
            return `https://lnesv3-conf.ado-tech.com/Default/CardCapture/config.json`;
        }
        return `https://lnesv3-conf.ado-tech.com/Default/Liveness/config.json`;
    }

    function setStyles(stylesObject) {
        const root = document.documentElement;
        root.style.setProperty('--background-color', stylesObject.backgroundColor);
        root.style.setProperty('--message-color', stylesObject.messageColor);
        root.style.setProperty('--message-back-color', stylesObject.messageBackgroundColor);
        root.style.setProperty('--guide-color', stylesObject.guideColor);
        root.style.setProperty('--success-color', stylesObject.successColor);
        root.style.setProperty('--error-color', stylesObject.errorColor);
        root.style.setProperty('--message-error-color', stylesObject.messageErrorColor);
        root.style.setProperty('--font-size', stylesObject.fontSize);
    }

    const fetchConfig = async () => {
        try {
            const response = await fetch(url(), { method: 'GET' });
            if (!response.ok) {
                throw new Error(`HTTP error! status: ${response.status}`);
            }
            const data = await response.json();
            console.log('data ->', data);
            setConfig(data);
            setStyles(data.styles)
        } catch (error) {
            const response = await fetch(defaultUrl(), { method: 'GET' });
            const data = await response.json();
            setConfig(data);
            setStyles(data.styles)
            console.error("Failed to fetch config:", error);
        } finally {
            setLoading(false);
        }
    };
    useEffect(() => {
        fetchConfig();
    }, []);

    if (configLoading) {
        return null
    }

    console.log('config afuera', config);
    return <LivenessV5 key={location.key} configLoading={configLoading} configValue={config} />
}
export function LivenessV5({configValue, configLoading}) {
    const containerRef = useRef();
    const guideAdoRef = useRef();
    const videoRef = useRef();
    const containerTextMessages = useRef();
    const containerGuideAdo = useRef();
    const textMessages = useRef();
    const scanLine = useRef();
    const imgBack = useRef();
    const [alertVisible, setAlertVisible] = useState();
    const [showFlash, setShowFlash] = useState();

    const {
        canvasRef,
        emitReadyCam,
        flashOn,
        projectName,
        loadingMetaData,
        showMessage,
        loading,
        showcheck,
        messagesLiveness,
        errorMessage,
        handleFlash,
        goBack,
        informativeText
    } = useLiveness({setShowFlash, configValue, configLoading, containerRef, guideAdoRef, videoRef, setAlertVisible, imgBack, scanLine, containerTextMessages, textMessages, containerGuideAdo})

    const isLuloProject = projectName.toLowerCase().includes('lulo');
    const showLoader = (!emitReadyCam || emitReadyCam === 'false') ? true : (emitReadyCam && emitReadyCam === 'true') ? loadingMetaData : false;

    const hideAlert = () => {
        setAlertVisible(false)
    }

    useEffect(() => {
        if (containerRef.current) {
          if (flashOn) {
            containerRef.current.classList.add('flash');
          } else {
            containerRef.current.classList.remove('flash');
          }
        }
      }, [flashOn]);

    function renderLoaderOrIcon() {
        if (showcheck) {
            return <img style={{ width: '49px', display: 'block' }} alt="result" id="result-image-ado" src={checkicon} />;
        } else if (isLuloProject) {
            return showLoader ? <LoaderLulo type={loadingMetaData ? 'v1' : 'v2'} /> : null;
        } else {
            return <LoaderIOS />;
        }
    }

    return (
        <div ref={containerRef} className='v1 container-liveness-ado hide-elements'>
            {alertVisible && <Alert message={errorMessage} onClose={hideAlert} />}
            {(loading && emitReadyCam !== "true") && (
                <div className='loader-container'>
                    {renderLoaderOrIcon()}
                </div>
            )}
            <div className="close-btn-wrapper">
                <div ref={imgBack} className="image-back-ado" onClick={goBack} ></div>
                {showFlash && <label>
                    <img width="30" alt="flash icon" src={`data:image/svg+xml,%3Csvg width='25px' height='25px' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M17.9105 10.7209H14.8205V3.52087C14.8205 1.84087 13.9105 1.50087 12.8005 2.76087L12.0005 3.67087L5.2305 11.3709C4.3005 12.4209 4.6905 13.2809 6.0905 13.2809H9.1805V20.4809C9.1805 22.1609 10.0905 22.5009 11.2005 21.2409L12.0005 20.3309L18.7705 12.6309C19.7005 11.5809 19.3105 10.7209 17.9105 10.7209Z' fill='%23${flashOn ? '000' : 'fff'}'/%3E%3C/svg%3E`}/>
                    <input style={{display: 'none'}} type="checkbox" onChange={handleFlash} />
                </label>}
            </div>

            <div ref={containerGuideAdo} className="container-guide-liveness-ado">
                {showMessage && (
                    <div ref={containerTextMessages} className="messages-ado-liveness-container">
                        <h2 ref={textMessages} className="text-ado-liveness">{messagesLiveness}</h2>
                        <h3 className='informative-text-ado'>{informativeText}</h3>
                    </div>
                )}
                <div ref={guideAdoRef} className={`rectangle-liveness-ado-content ${flashOn ? 'flash' : ''}`}>
                    <div style={{display: 'none'}} ref={scanLine} className="scan-line-ado"></div>
                    <video className="container-camera-liveness-ado" ref={videoRef} autoPlay playsInline/>
                </div>
            </div>

            <div id="container-result-image-ado" style={{display: 'none'}}>
                <h2>Image result</h2>
                <img style={{width: '100%', display: 'none'}} alt="result" id="result-image-ado"/>
            </div>
            <div id="container-result-video-ado" style={{display: 'none'}}>
                <h2>Video result</h2>
                <video id="video-result-ado" controls={true} autoPlay playsInline style={{display: 'none'}}></video>
            </div>
            <canvas id="canvas-view" ref={canvasRef} style={{display: 'none', width: '100%', objectFit: 'cover', height: '100vh'}}  />
        </div>
    )
}
